import { z } from 'zod'
import { accessLevelSchema, sectionSchema } from './access.ts'

export const adminUserSchema = z.object({
  email: z.email(),
  name: z.string().min(1),
  role: z.string().min(1),
  access: accessLevelSchema,
  sections: z.array(sectionSchema),
})

export const sessionSchema = z.object({
  user: adminUserSchema,
})

export const loginRequestSchema = z.object({
  email: z.email('Проверьте почту — кажется, в адресе опечатка.'),
  password: z.string().min(6, 'Неверная почта или пароль. Попробуйте ещё раз.'),
  remember: z.boolean().default(true),
})

export type AdminUser = z.infer<typeof adminUserSchema>
export type Session = z.infer<typeof sessionSchema>
export type LoginRequest = z.input<typeof loginRequestSchema>
